// extracted by mini-css-extract-plugin
export default {"base":"PrincipalTorneosInt_base__Sw6Wg","titulo":"PrincipalTorneosInt_titulo__hZe9g","contenedorCuadros":"PrincipalTorneosInt_contenedorCuadros__Ct9Tm"};